import { render } from "./TeacherScheduleView.vue?vue&type=template&id=73317714"
import script from "./TeacherScheduleView.vue?vue&type=script&lang=js"
export * from "./TeacherScheduleView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__